import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import {Handle, HandleType} from 'reactflow';

import {defaultHandleProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeHandleUtils';
import {HandleInteractionProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';
import {defaultNodeHandleIdGenerator} from 'ui-library/reactflow/nodes/SimpleBenchlingNode/sub-components/SimpleBenchlingNodeHandle';

/**
 * Invisible handles used to draw edges between two nodes.
 */
export function InvisibleNodeHandle(props: {
  nodeId: string;
  handleType: HandleType;
  nodeHeaderHandleIdGenerator?: (nodeId: string, handleType: HandleType) => string | null;
  additionalProps?: HandleInteractionProps;
}): JSX.Element | null {
  const handleId = props.nodeHeaderHandleIdGenerator
    ? props.nodeHeaderHandleIdGenerator(props.nodeId, props.handleType)
    : defaultNodeHandleIdGenerator(props.nodeId, props.handleType);
  return handleId ? (
    <Handle
      {...defaultHandleProps(props.handleType)}
      id={handleId}
      className={css(styles.handle)}
      {...props.additionalProps}
      {...getTestProps({
        component: 'InvisibleNodeHandle',
        element: 'root',
      })}
    />
  ) : null;
}

const styles = StyleSheet.create({
  handle: {
    opacity: 0,
    pointerEvents: 'none',
    width: '1px',
    height: '1px',
  },
});
